module.exports = __webpack_public_path__ + "img/cc.2fa48609.svg";